import { type ActivationErrorTypes, type BTLoginTypes } from "types/enum";

import { isNullOrUndefined } from "utilities/object/object";

import { type PreviousActivation } from "commonComponents/entity/credentials/Credentials/Credentials.api.types";

export enum UserActivationMethods {
    LinkAccount = 0,
    CreateAccount = 1,
}

export function isValidUserActivationMethod(
    activationMethod: UserActivationMethods | undefined,
): boolean {
    if (isNullOrUndefined(activationMethod) || isNaN(activationMethod)) {
        return false;
    }
    return Object.values(UserActivationMethods).includes(activationMethod);
}

export interface IUserActivationLinkRequest {
    username: string;
    shareToken: string;
    isSignedIn: true;
}

export enum ExternalEntitiesWithUserActivation {
    BidSubmitted = 1,
    BidDeclined = 2,
    PurchaseOrderApproved = 3,
    PurchaseOrderDeclined = 4,
}
export interface IAuth0ActivationResponse {
    globalUserId: number;
    loginType: BTLoginTypes;
    previousActivation: PreviousActivation;
    userId: number;
    errorType: ActivationErrorTypes;
    logoSrc: string;
    sessionLoginType: BTLoginTypes;
    builderName: string;
}

export class Auth0ActivationResponse implements IAuth0ActivationResponse {
    constructor(data: IAuth0ActivationResponse) {
        this.globalUserId = data.globalUserId;
        this.loginType = data.loginType;
        this.previousActivation = data.previousActivation;
        this.userId = data.userId;
        this.errorType = data.errorType;
        this.logoSrc = data.logoSrc;
        this.sessionLoginType = data.sessionLoginType;
        this.builderName = data.builderName;
    }
    globalUserId: number;
    loginType: BTLoginTypes;
    previousActivation: PreviousActivation;
    userId: number;
    errorType: ActivationErrorTypes;
    logoSrc: string;
    sessionLoginType: BTLoginTypes;
    builderName: string;
}

export interface IFinalizeActivationRequest {
    shareToken: string;
    emailAddress: string;
}
